import { FaGoogle, FaStar } from "react-icons/fa";

export default function Testimonials() {
  const reviews = [
  {
    text: "Rankridge provides the perfect blend of academics and care. My daughter felt supported not just in studies but also in building confidence.",
    name: "Ananya S.",
    role: "Parent, NEET Aspirant",
  },
  {
    text: "The structured JEE coaching and constant mentor guidance made me confident for Advanced. Weekly tests kept me sharp throughout.",
    name: "Karthik R.",
    role: "Student, IIT-JEE Long Term",
  },
  {
    text: "Rankridge focuses equally on discipline and academics. I have seen my son grow more responsible, while improving his ranks consistently.",
    name: "Meera P.",
    role: "Parent, Grade 11",
  },
//   {
//     text: "Teachers are approachable, and study material is top-notch. I cracked NEET with a good score thanks to their mock exams and personal mentoring.",
//     name: "Ishita D.",
//     role: "Alumna, NEET 2024 Batch",
//   },
//   {
//     text: "The stress-free environment here makes learning fun. The labs, digital resources, and booster classes are outstanding.",
//     name: "Rahul V.",
//     role: "Student, Intermediate BiPC",
//   },
];


  return (
    <div className="bg-gradient-to-r from-green-50 to-white py-12 px-6">
      <h2 className="text-2xl font-bold text-center mb-10">
        What Our Students & Parents Say
      </h2>
      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">


        {reviews.map((review, index) => (

          <div
            key={index}
            className="bg-white rounded-2xl shadow-lg p-6 flex flex-col justify-between hover:shadow-xl transition relative"
          >
            <div className="flex justify-between">
                <div>
                        <FaGoogle className="absolute text-blue-500 text-lg" />
</div>
            {/* Google Icon Top Right */}

            {/* Stars */}
            <div className="flex gap-1 text-yellow-500 mb-4">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} />
              ))}
            </div>
</div>
            {/* Quote */}
            <p className="text-gray-700 italic mb-6 leading-relaxed">
              “{review.text}”
            </p>

            {/* Reviewer */}
            <div>
              <p className="font-bold text-gray-900">{review.name}</p>
              <p className="text-sm text-gray-500">{review.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}